// Persona-flagga (NPF). Lagras i localStorage (P0), default null → child/adult
// avgörs av befintlig childMode-gate. Samma mönster som childMode.ts: efter
// setItem måste vi dispatcha 'storage'-eventet manuellt eftersom webbläsaren
// annars bara fyrar det i andra flikar, inte i den flik som gjorde ändringen
// (jfr DarkModeToggle.tsx / childMode.ts). Utan detta byts inte persona-temat
// förrän efter en omladdning.
//
// Per-användare-nyckel ('persona:<userTag>') plus en global spegel ('persona').
// Spegeln behövs eftersom App.tsx och useActivePersona läser personan UTAN att
// ha en userTag i scope (de anropar getStoredPersona() utan argument → global
// nyckel). Väljaren skriver alltid båda så att fallbacken hålls i synk.
import type { Persona } from '@/personas/types';

const GLOBAL_PERSONA_KEY = 'persona';

const personaKey = (userTag?: string): string =>
  userTag ? `persona:${userTag}` : GLOBAL_PERSONA_KEY;

const VALID_PERSONAS: readonly Persona[] = ['child', 'teen', 'adult'];

const isPersona = (value: string | null): value is Persona =>
  value !== null && (VALID_PERSONAS as readonly string[]).includes(value);

export const getStoredPersona = (userTag?: string): Persona | null => {
  const stored = localStorage.getItem(personaKey(userTag));
  return isPersona(stored) ? stored : null;
};

export const setPersona = (userTag: string | undefined, persona: Persona): void => {
  if (userTag) localStorage.setItem(personaKey(userTag), persona);
  localStorage.setItem(GLOBAL_PERSONA_KEY, persona); // spegel för App.tsx-fallback (ingen tag i scope)
  window.dispatchEvent(new Event('storage'));
};
